import {makeRequest} from '../../Services/API';

// export function guardarDespesa(nome, nif, motivo, valor,startDate,baseImage, utilizador) {
//    let params =[{
//     numeroCliente: utilizador.numeroCliente,
//     nomeCliente: utilizador.nomeCliente,
//     nomeCurtoCliente: utilizador.nomeCliente,
//     language: "",
//     nomeDesp: "",
//     data: startDate,
//     contribuinte: nif,
//     motivo: motivo,
//     valor: valor,
//     tipo: nome,
//     foto: baseImage,
//     base64: ""
//   }]

//

//     return makeRequest(
//       `/backend/despesas/POR/Criar`,
//       params
//     );
//   }

import {makeRequestGet} from '../../Services/API';

export function guardarDespesa(nome, nif, motivo, valor, startDate, baseImage, utilizador, moeda, tipoDespesa, observacoes, terceiros, nomeU) {
    let params = {
        numeroCliente: '',
        nomeCliente: nomeU,
        nomeCurtoCliente: nomeU,
        language: '',
        nomeDesp: nome,
        data: startDate,
        contribuinte: nif,
        motivo: motivo,
        valor: valor,
        tipo: tipoDespesa,
        foto: baseImage,
        base64: '',
        moeda: moeda,
        utilizador: utilizador,
        observacoes: observacoes,
        terceiros: terceiros,
    };
    return makeRequest(`/backend/despesas/POR/CriarWeb`, params);
}

export async function GetTipoDespesaMoedas(lang) {
    const token = localStorage.getItem('token');
    return makeRequest(`/backend/tiposDespesa/${lang}/`, {
        headers: {
            Authorization: `token ${token}`,
        },
    });
}

export function getVIES(countryCode, vatNumber) {
    const params = {
        countryCode: countryCode,
        vatNumber: vatNumber,
    };
    return makeRequest('/backend/despesas/POR/VIES', params);
}
